import { render, staticRenderFns } from "./CreatePortalCompany.vue?vue&type=template&id=16f733c4&"
import script from "./CreatePortalCompany.vue?vue&type=script&lang=js&"
export * from "./CreatePortalCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports